<div id="layout-wrapper">
  <app-horizontaltopbar></app-horizontaltopbar>

  <div class="main-content">
    <div class="page-content">
      <ngx-spinner [name]="layoutSpinner" bdColor="rgba(0, 0, 0, 0)" size="medium" color="#03a9f4" type="ball-spin-fade" [fullScreen]="false"><p style="color: white"></p></ngx-spinner>
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer></app-footer>
  <app-rightsidebar></app-rightsidebar>
</div>
